// SMTP ayarları servisi
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || (process.env.NODE_ENV === 'development' ? 'http://localhost:5000/api' : 'https://crm.apro.com.tr/api');

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Token'ı her istekte ekle
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const smtpService = {
  // SMTP ayarlarını getir
  getSmtpSettings: () => api.get('/smtp/settings'),
  
  // SMTP ayarlarını güncelle
  updateSmtpSettings: (data) => api.put('/smtp/settings', data),
  
  // SMTP bağlantısını test et
  testSmtpConnection: (data) => api.post('/smtp/test', data),
};
